import {createSlice} from '@reduxjs/toolkit';

const eligibilitySlice = createSlice({
  name: 'eligibilitySlice',
  initialState: {
    breResponse: null,
    deviationResponse: null,
    roleList: null,
    deviationApiSuccess: false,
    eligibleToProceed: false,
    proceedStage: null,
  },
  reducers: {
    setBreResponse: (state, action) => {
      state.breResponse = action.payload;
    },
    setDeviationResponse: (state, action) => {
      state.deviationResponse = action.payload;
    },
    setRoleList: (state, action) => {
      state.roleList = action.payload;
    },
    setDeviationApiSuccess: (state, action) => {
      state.deviationApiSuccess = action.payload;
    },
    setEligibleToProceed: (state, action) => {
      state.eligibleToProceed = action.payload;
    },
    setProceedStage: (state, action) => {
      state.proceedStage = action.payload;
    },
    resetEligibilityCheck: state => {
      state.deviationResponse = null;
      state.breResponse = null;
      state.deviationApiSuccess = false;
    },
    resetAllEligibilityCheck: state => {
      state.breResponse = null;
      state.deviationResponse = null;
      state.roleList = null;
      state.deviationApiSuccess = false;
      state.eligibleToProceed = false;
      state.proceedStage = null;
    },
  },
});

export const {
  setBreResponse,
  setDeviationResponse,
  setRoleList,
  setDeviationApiSuccess,
  setEligibleToProceed,
  setProceedStage,
  resetEligibilityCheck,
  resetAllEligibilityCheck,
} = eligibilitySlice.actions;

export default eligibilitySlice.reducer;
